module.exports = __webpack_public_path__ + "img/SMS.584faff9.svg";